import images from 'assets/images/images'
import useTranslate from 'hooks/useTranslate';
import {Trans} from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {setUserChoises} from 'redux/features/general/generalSlice';
import { stages } from 'utils/Constants';

const StageTypeSelection = ({ setRegisterState, isLogin }) => {
    const {t} = useTranslate()
    const {registerData} = useSelector(state => state.register)
    const dispatch = useDispatch()
    const selectType = (type) => {
        if(type == "address"){
            dispatch(setUserChoises({deliveryType: 2, deliveryTab:2}))
            if(isLogin){
               setRegisterState(stages.STAGE_ADD_ADDRESS)
            }else{
               setRegisterState(stages.STAGE_ADDRESSES)
            }
        }else{
            dispatch(setUserChoises({deliveryType: 1, deliveryTab:1}))
            setRegisterState(stages.STAGE_CHOICE_BRANCH)
            //devamı buraya gelecek... 
        }
       
        //isLogin ? () => setRegisterState(stages.STAGE_ADD_ADDRESS) :  () => setRegisterState(stages.STAGE_ADDRESSES)
    }
    return (
        <div className="d-flex flex-column align-items-center">

            <div className="d-flex flex-column gap-3 text-center register-login">
                <h1 className="header-l">
                    {t('hello')} {registerData?.firstName}
                </h1>
                <div className="body-m">
                    {t('howReciveOrderQuestion')}
                </div>
            </div>

            <div className="d-flex align-items-center gap-4 mt-5">
                <div onClick={() => selectType("address")} className="card card-square bg-white cursor-pointer">
                    <img src={images.colorfulMotorcycle} alt="" />
                    <div className="header-m text-center">
                        {t('cometoMyAddress')}
                    </div>
                </div>
                <div onClick={() => selectType("branch")} className="card card-square bg-white cursor-pointer">
                    <img src={images.location} alt="" />
                    
                        
                    <div className="header-m text-center">
                    <Trans
                        i18nKey='wantToBuyFromBranch'
                        components={{ break: <br /> }}
                    />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default StageTypeSelection